

import XLSX from 'xlsx';
import { saveAs } from 'file-saver'

function LoadData() {
    // var xlsxChart=new XLSXChart();
    // var opts = {
    //     file: "chart.xlsx",
    //     chart: "column",
    //     titles: [
    //         "Title 1",
    //         "Title 2",
    //         "Title 3"
    //     ],
    //     fields: [
    //         "Field 1",
    //         "Field 2",
    //         "Field 3",
    //         "Field 4"
    //     ],
    //     data: {
    //         "Title 1": {
    //             "Field 1": 5,
    //             "Field 2": 10,
    //             "Field 3": 15,
    //             "Field 4": 20 
    //         },
    //         "Title 2": {
    //             "Field 1": 10,
    //             "Field 2": 5,
    //             "Field 3": 20,
    //             "Field 4": 15
    //         },
    //         "Title 3": {
    //             "Field 1": 20,
    //             "Field 2": 15,
    //             "Field 3": 10,
    //             "Field 4": 5
    //         }
    //     }
    // };
    // xlsxChart.writeFile (opts, function (err,data) {
    //   // consol ("File: ", opts.file);
      
    // });
    
    // // xlsxChart.generate (opts, function (err, data) {
    // //     res.set ({
    // //       "Content-Type": "application/vnd.ms-excel",
    // //       "Content-Disposition": "attachment; filename=chart.xlsx",
    // //       "Content-Length": data.length
    // //     });
    // //     res.status (200).send (data);
    // // });
    
    
     
    
    
}

function replaceAtSymbolInTableHeaders(tableId) {
  const table = document.getElementById(tableId);
  if (!table) return null; // Return null if the table doesn't exist

  // Create a deep clone of the table (does not affect the original table)
  const clonedTable = table.cloneNode(true);

  const headers = clonedTable.getElementsByTagName("th");

  for (let th of headers) {
      if (th.innerText.includes("@")) {
        th.innerText = th.innerText.replaceAll(/@/g, "_").replaceAll(/\s+/g, "_");
      }
  }

  return clonedTable; // Return the modified cloned table
}

// Decide whether a cell's text should be forced to a string in the export.
// SheetJS (with raw:false) tries to auto-detect cell types. For values that are
// not numbers it falls back to date parsing via `new Date(text)`, and JS's very
// lenient parser can turn text like "EJECTOR MARK@012" into a bogus date
// ("12-03-2001 12:00:10 AM"). We keep genuine numbers as numbers, but force any
// text that contains letters or the "@" code separator to stay a string.
function shouldForceStringCell(text) {
  var t = (text == null ? "" : String(text)).trim();
  if (t.length === 0) return false;

  // Keep real numbers numeric (handles commas, currency, %, parentheses and
  // scientific notation like "1e3"), so column sums keep working in Excel.
  var cleaned = t.replace(/[,\s$₹%()]/g, "");
  if (cleaned !== "" && cleaned !== "-" && cleaned !== "+" && !isNaN(Number(cleaned))) return false;

  // Only protect values that could be misread as a date (they contain letters
  // or the "@" separator used in reason codes).
  return /[A-Za-z@]/.test(t);
}

// Clones the table and tags text cells with t="s" so Excel/SheetJS does not
// coerce them into dates or numbers. Returns a detached clone safe to export.
function markTextCellsAsString(tableId) {
  var table = document.getElementById(tableId);
  if (!table) return null;

  var clonedTable = table.cloneNode(true);
  var cells = clonedTable.querySelectorAll("td, th");
  for (var i = 0; i < cells.length; i++) {
    var cell = cells[i];
    var text = cell.textContent || "";
    if (shouldForceStringCell(text)) {
      cell.setAttribute("t", "s");
    }
  }
  return clonedTable;
}

function generateExcelFile(e, dateTime) {
  var workbook = XLSX.utils.book_new();
  var table = markTextCellsAsString(e) || document.getElementById(e);
  var ws1 = XLSX.utils.table_to_sheet(table, { raw: false });
  XLSX.utils.book_append_sheet(workbook, ws1, "Sheet1");
  if (!dateTime) { dateTime = new Date(Date.now()) }
  XLSX.writeFile(workbook, `${e}${new Date(dateTime).toLocaleString()}.xlsx`);
}



function generateExcelTextFile(e, dateTime) {
  var workbook = XLSX.utils.book_new();
  var ws1 = XLSX.utils.table_to_sheet(document.getElementById(e), { raw: true });
  XLSX.utils.book_append_sheet(workbook, ws1, "Sheet1");
  if (!dateTime) { dateTime = new Date(Date.now()) }
  XLSX.writeFile(workbook, `${e}${new Date(dateTime).toLocaleString()}.xlsx`);
}



function generateExcelFileFull(data, view) {
  var workbook = XLSX.utils.book_new();
  var ws1 = XLSX.utils.json_to_sheet(data);
  XLSX.utils.book_append_sheet(workbook, ws1, "Sheet1");

/* set up async GET request */
// var req = new XMLHttpRequest();
// req.open("GET", url, true);
// req.responseType = "arraybuffer";

// req.onload = function(e) {
//   var data = new Uint8Array(req.response);
//   var workbook = XLSX.read(data, {type:"array"});

  /* DO SOMETHING WITH workbook HERE */
// }

// req.send();

XLSX.writeFile(workbook,`${view}${new Date(Date.now()).toLocaleString()}.xlsx`);
}

export {
  LoadData,
  generateExcelFile,
  generateExcelFileFull,
  generateExcelTextFile,
}